module.exports = __webpack_public_path__ + "img/left-leg_active.d5d7f089.png";